import { observer } from "mobx-react-lite";
import { Pressable } from "react-native";
import { Text } from "tamagui";
import type { PlanTagWithOptions } from "../../plans/PlanModel";

const bodyStyle = {
  fontFamily: "$subtextLabel",
} as const;

export const TagPill = observer(
  ({ tag, onPress }: { tag: PlanTagWithOptions; onPress?: () => void }) => {
    let extraLabel = "";

    if (tag.count !== undefined && tag.completed !== undefined) {
      extraLabel = `(${tag.completed}/${tag.count})`;
    } else if (tag.count !== undefined) {
      extraLabel = `(${tag.count})`;
    }

    return (
      <Pressable onPress={onPress} disabled={!onPress}>
        <Text
          {...bodyStyle}
          alignSelf="flex-start"
          style={{ backgroundColor: tag.color, color: tag.textColor }}
          borderRadius={100}
          opacity={tag.dimmed ? 0.3 : 1}
          paddingHorizontal="$medium"
          paddingVertical="$small"
          numberOfLines={1}
          fontWeight={"bold"}
          fontSize={12}
          textDecorationLine={tag.archived ? "line-through" : undefined}
        >
          {tag.label} {extraLabel}
        </Text>
      </Pressable>
    );
  },
);
